<template>
  <time class="post_date c5a">{{ date }}</time>
</template>

<script>
export default {
  props: ['date'],
}
</script>

<style lang="css" scoped>
.post_date {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/fanClub/column/parts/Time.vue